import { render, staticRenderFns } from "./ResetPasswordLandPage.vue?vue&type=template&id=5390272a&"
import script from "./ResetPasswordLandPage.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordLandPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports